import { ref, Ref } from 'vue'
import browser from 'webextension-polyfill'

import { logError } from '@/shared/logger'

const setCameraAccess = async () => {
  await browser.tabs.create({
    url: '/media.html#/',
  })
}

export function useCameraAccess(): {
  cameraEnabled: Ref<boolean>
  setCameraAccess: () => Promise<void>
} {
  const cameraEnabled = ref(false)

  ;(async () => {
    try {
      const devices = (await navigator.mediaDevices?.enumerateDevices()) || []
      for (const device of devices) {
        if (device.kind === 'videoinput') {
          if (device.kind === 'videoinput' && device.label !== '') {
            cameraEnabled.value = true
          }
        } else {
          continue
        }
      }
    } catch (error) {
      cameraEnabled.value = false
      logError(`Error while setting up camera access:`, error)
    }
  })()

  return {
    cameraEnabled,
    setCameraAccess,
  }
}
